import { createBasketItem, generateDeeplink, BTX_BNT } from '@vfde-fe/sails_core';
import { selectDiscountIds, selectSalesChannel, selectSelectedHardwareId, selectSelectedSubLevelId } from 'Container/App/selector';
import { all, select, takeLatest } from 'redux-saga/effects';
import { GO_TO_BASKET } from './constant';
import { SALECSCHANNEL_MAP, ENV_MAP } from '../../constant';

/**
 * generate deep link
 * TODO: rename to generateDeepLinkSaga
 */
export function* generateDeepLink () {

    const [
        salesChannel,
        subLevelId,
        atomicDeviceId,
        discountIds,
    ] = yield all([
        select(selectSalesChannel),
        select(selectSelectedSubLevelId),
        select(selectSelectedHardwareId),
        select(selectDiscountIds),
    ]);

    const btx = BTX_BNT;
    const environment = ENV_MAP[window.location.hostname];

    const basketItem = createBasketItem(
        subLevelId,
        atomicDeviceId,
        discountIds
    );

    return generateDeeplink(
        SALECSCHANNEL_MAP[salesChannel],
        btx,
        environment,
        basketItem
    );
}

/**
 * export redirectToBasket
 */
export function* redirectToBasket () {
    const url = yield generateDeepLink();
    window.location.assign(url);
}

/**
 * export generator function priceSectionSaga
 */
export default function* priceSectionSaga () {
    yield takeLatest(GO_TO_BASKET, redirectToBasket);
}
